import BaseApiRequest from "./BaseApiRequest";
import { ESC_REQUEST_URL } from "../ApiUrls";
import { METHOD } from "../Constants";

import { getCurrentUserParameters } from "../../Utils/CommonUtilities";

export default class RequestEscRequest extends BaseApiRequest {
  method = METHOD.HTTP.POST;

  body = {};

  url = ESC_REQUEST_URL;

  constructor(data) {
    super();
    this.body = data;
  }

  getMethod = () => this.method;

  getUrl = () => getCurrentUserParameters(this.url);

  getBody = () => this.body;
}
